import React, { useCallback, useEffect, useRef, useState } from "react";

import TableControlButton from "./TableControlButton";
import Select from "common-ui-components/components/select";

import columnChooserIcon from "../../icons/column-chooser.svg";
import { useTableManagerContext } from "../TableManagerContext";
import API from "common-ui-components/components/utils/API";

const ColumnChooser = ({ handleAction }) => {
  const { columns, tableControls, setTableControls, setColumnsToDisplay, tableControlsVisibility,url } =
    useTableManagerContext();

  const initialColumns = columns.reduce((acc, val, index) => {
    if (!val.initiallyHidden) {
      acc.push(index);
    }
    return acc;
  }, []);

  const [activeColumns, setActiveColumns] = useState(initialColumns);
  const [selectedColumns, setSelectedColumns] = useState(initialColumns);
  const appliedColumnsRef = useRef(initialColumns);

  useEffect(() => {
    const newInitialColumns = columns.reduce((acc, val, index) => {
      if (!val.initiallyHidden) {
        acc.push(index);
      }
      return acc;
    }, []);

    setActiveColumns(newInitialColumns);
    setSelectedColumns(newInitialColumns);
    appliedColumnsRef.current = newInitialColumns;
  }, [columns]);

  const updateInitiallyHidden = (columns, visibleIndexes) => {
    const visibleSet = new Set(visibleIndexes);

    return columns.map((column, index) => ({
      ...column,
      initiallyHidden: !visibleSet.has(index),
    }));
  };

  const shareChoosenColumns=async(columns)=>{
    if (url == null || url.length === 0) return;
    const [actualURL, searchParams] = url.split("?");
    const params = new URLSearchParams(searchParams);
    params.append("page",0);
    params.append("size",10);
    const serverTableConfig = { columns, filter: [], search: [], sort: {} };
    try 
    {
      const response = await API.post(`${actualURL}?${params}`, serverTableConfig);
    } 
    catch (error) 
    {
      ;
    }
  }

  const handleReset = () => {
    setActiveColumns(initialColumns);
    setSelectedColumns(initialColumns);
    appliedColumnsRef.current = initialColumns;
    const updatedColumns = updateInitiallyHidden(columns, appliedColumnsRef.current);
    shareChoosenColumns(updatedColumns)
  };

  const handleApply = () => {
    setActiveColumns(selectedColumns);
    appliedColumnsRef.current = selectedColumns;
    const updatedColumns = updateInitiallyHidden(columns, appliedColumnsRef.current);
    const filteredColumns = updatedColumns.filter(item => item.accessor !== "__action__");
    //console.log("updatedColumns", filteredColumns);
    shareChoosenColumns(filteredColumns);
  };

  const onClose = useCallback(() => {
    setSelectedColumns(appliedColumnsRef.current);
    setTableControls((prevTableControls) => ({
      ...prevTableControls,
      chooseColumn: false,
    }));
  }, [setTableControls]);

  const handleColumnSelect = (_option, index) => {
    setSelectedColumns((prevSelectedColumns) => {
      if (prevSelectedColumns.includes(index))
        return prevSelectedColumns.filter((val) => val !== index);
      return prevSelectedColumns.concat(index);
    });
  };

  useEffect(() => {
    setColumnsToDisplay(
      columns.filter((_val, index) => activeColumns.includes(index))
    );
  }, [activeColumns, columns, setColumnsToDisplay]);

  return (
    tableControlsVisibility.columChooseNeeded && <Select
      triggerComponent={TableControlButton}
      triggerProps={{
        name: "Column Chooser",
        icon: columnChooserIcon,
        control: "chooseColumn",
        tableControls,
        handleAction,
      }}
      options={columns
        .filter(({ title }) => title !== "Action")
        .map(({ title }) => title)
      }
      multiple={{ handleApply, handleReset, optionsText: "Columns",applyText:"Save" }}
      active={selectedColumns}
      onOptionSelect={handleColumnSelect}
      onClose={onClose}
    />
  );
};

export default ColumnChooser;
